import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DataType } from 'shared/types/data-type';
import { ID } from 'shared/types/id';
import { useTheme } from 'styled-components';

import * as Styled from './cta-container.style';

export type CtaContainerProps = {
  id: ID;
  title: string;
  detailUrl: string;
  onClick?: (id: ID) => void;
  isFrozen?: boolean;
  children: React.ReactNode;
  preventInteraction?: boolean;
};

export const CtaContainer: React.FC<CtaContainerProps> = ({
  id,
  title,
  detailUrl,
  onClick,
  isFrozen,
  children,
  preventInteraction,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  if (preventInteraction) {
    return (
      <Styled.ClickContainer
        data-component-type={DataType.Goal}
        data-id={id}
        data-title={title}
      >
        {children}
      </Styled.ClickContainer>
    );
  }

  if (isFrozen || onClick) {
    const _onClick = onClick ? () => onClick(id) : undefined;
    return (
      <Styled.ClickContainer
        data-component-type={DataType.Goal}
        data-id={id}
        data-title={title}
        onClick={_onClick}
      >
        {children}
      </Styled.ClickContainer>
    );
  }

  if (theme.isTouchDevice) {
    const _onClick = () => navigate(detailUrl);
    return (
      <Styled.ClickContainer
        data-component-type={DataType.Goal}
        data-id={id}
        data-title={title}
        onClick={_onClick}
      >
        {children}
      </Styled.ClickContainer>
    );
  }

  const preventDefault = (e: React.MouseEvent) => {
    if (e.metaKey || e.shiftKey || e.ctrlKey) {
      e.preventDefault();
      return;
    }

    e.stopPropagation();
  };

  return (
    <Styled.LinkContainer
      data-component-type={DataType.Goal}
      data-id={id}
      data-title={title}
      to={detailUrl}
      onClick={preventDefault}
    >
      {children}
    </Styled.LinkContainer>
  );
};
